export const deviceType = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  TABLET: 'tablet',
};

export const imageAspectRatioClass = {
  '16:9': 'vs-16-9',
  '1:1': 'vs-1-1'
};
export const featuredColors = {
  lightBlue: '#C7EDFF',
  white: '#FFFFFF',
  xLightGray: '#F7F7F7',
  black: 'black',
  primaryBlue: '#143cb1'
}
export const darkColors = ['black', 'primaryBlue'];
